/* eslint-disable class-methods-use-this */
import { useEffect } from 'react'
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  RouterProviderProps,
  useLocation,
  useNavigationType,
} from 'react-router-dom'

import env from '@core/env'
import * as Sentry from '@sentry/react'

import { ObservabilityProviderInterface, tracePropagationTargetsByEnv } from '.'
import { ignoredErrorPatterns } from './error-filters'

export class SentryProvider implements ObservabilityProviderInterface {
  setup(): any {
    if (env.MODE !== 'development' && env.SENTRY_DSN) {
      return Sentry.init({
        dsn: env.SENTRY_DSN,
        environment: env.ENV,
        release: `ftg-saas-ui@${env.SENTRY_RELEASE}`,
        tracePropagationTargets: tracePropagationTargetsByEnv[env.ENV] || [],
        integrations: [
          Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
          }),
          Sentry.inboundFiltersIntegration({
            ignoreErrors: ignoredErrorPatterns,
          }),
          Sentry.captureConsoleIntegration({
            levels: ['error', 'warn'],
          }),
        ],
        tracesSampleRate: env.SENTRY_TRACES_SAMPLE_RATE,
      })
    }
  }

  captureMessage = (message: string): void => {
    Sentry.captureMessage(message)
  }

  captureException = (error: Error): void => {
    Sentry.captureException(error)
  }

  setUser = (payload): void => {
    Sentry.setUser(payload)
  }

  setContext = (name: string, context: { [key: string]: unknown } | null) => {
    Sentry.setContext(name, context)
  }

  createRouter = (router: any): RouterProviderProps['router'] => {
    const sentryBrowser = Sentry.wrapCreateBrowserRouter(createBrowserRouter)

    return sentryBrowser(router)
  }
}
